import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Chip } from "@corporate-trip-planner-fe/ui-styles";
export var renderChipList = function (selected, visibleCount) {
    if (visibleCount === void 0) { visibleCount = 3; }
    if (!selected || selected.length === 0)
        return "";
    var visible = selected.slice(0, visibleCount);
    var hiddenCount = selected.length - visibleCount;
    return (_jsxs("div", { style: { display: "flex", gap: "4px", flexWrap: "wrap" }, children: [visible.map(function (value) { return (_jsx(Chip, { children: String(value) }, value)); }), hiddenCount > 0 && (_jsx(Chip, { children: "+".concat(hiddenCount.toString(), " more") }))] }));
};
